<script lang="ts">
    import * as Breadcrumb from "$lib/components/ui/breadcrumb/index.js";
    import { useProjectCustomer } from "../hooks/useProjectCustomer";
    import { location } from "svelte-spa-router";
    import { t  } from 'svelte-i18n'
  import { isEditActive } from "$src/application/main/mainTemplateStore";
  import { getCustomerInfo } from "$src/domain/customers/utils/customer-info-utils";

    export let groupStoreId: number;
    export let projectId: number;
    
    let queryCustomer = useProjectCustomer(groupStoreId, projectId);
    
    // function isDocumentLocation(location: string) {
    //     const regex = /^\/gs\/[^\/]+\/projects\/[^\/]+\/documents(\/[^\/]+)?\/?$/;

    //     return regex.test(location);
    // }

    // function isInvoiceLocation(location: string) {
    //     const regex = /^\/gs\/[^\/]+\/projects\/[^\/]+\/invoices(\/[^\/]+)?\/?$/;

    //     return regex.test(location);
    // }

    // function isPictureLocation(location: string) {
    //     const regex = /^\/gs\/[^\/]+\/projects\/[^\/]+\/pictures(\/[^\/]+)?\/?$/;

    //     return regex.test(location);
    // }
</script>

{#if $queryCustomer.isSuccess}
    <Breadcrumb.Separator class="hidden sm:flex" />
    <Breadcrumb.Item>
        <Breadcrumb.Link href={`#/gs/${groupStoreId}/customers/${$queryCustomer.data.id}`}  asChild={$isEditActive}>
            {getCustomerInfo($queryCustomer.data)}
        </Breadcrumb.Link>
    </Breadcrumb.Item>
    <Breadcrumb.Separator />
    <Breadcrumb.Item>
        <Breadcrumb.Link href={`#/gs/${groupStoreId}/projects/${projectId}`}  asChild={$isEditActive}>
            {projectId}
        </Breadcrumb.Link>
    </Breadcrumb.Item>
{/if}